async function loadComponents() {
    const data = await fetch('/.netlify/functions/get-components')
        .then(res => res.json())
        .catch(err => console.error(err));

    return data;
}

export default loadComponents;
